<template>
    <div>
        <v-dialog v-model="dialog" width="600">
            <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
                <v-card-title style="background-color: #536091 !important; display: flex; justify-content: space-between; align-items: center; color: white;">
                    <div>
                        <span class="font-weight-bold text-h6" style="font-family: Saira Condensed, sans-serif;">{{ main_title }}</span>
                        <div class="text-caption" style="font-family: Saira Condensed, sans-serif;">{{ sub_title }}</div>
                    </div>
                    <v-btn :disabled="loading" flat icon color="red" @click="closeDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-alert type="warning" prominent border="left" color="amber darken-2">
                    {{ $t('AlertDialog.Guess_The_Balance.GTB_Warning_Guide') }}
                </v-alert>
                <v-card-text style="overflow-y: auto; max-height: calc(100vh - 200px);">
                    <!-- <v-card title="Bonus Hunt" flat></v-card> -->
                    <v-form ref="form" class="mt-4">
                        <v-row v-if="action == 'add'" dense style="font-family: Saira Condensed, sans-serif;">
                            <v-col cols="12">
                                <div class="d-flex justify-end">
                                    <v-tooltip 
                                        :text="$t('Tooltip.Sync_Bonus_Hunt')" 
                                        location="top"
                                    >
                                        <template #activator="{ props }">
                                            <v-btn
                                                v-bind="props"
                                                variant="outlined"
                                                density="comfortable"
                                                color="primary"
                                                :loading="loadingBonusHuntList"
                                                @click="syncBonusHunt"
                                                style="font-family: Saira Condensed, sans-serif;"
                                            >
                                                <v-icon left>mdi-sync</v-icon>
                                                
                                                {{ $t('Buttons.Sync') }}
                                            </v-btn>
                                        </template>
                                    </v-tooltip>
                                </div>
                            </v-col>
                            <v-col cols="12" class="pt-2">
                                <v-autocomplete
                                    :rules="[formRules.required]"
                                    :label="$t('Fields_Label.Guess_The_Balance.Bonus_Hunt')"
                                    v-model="bonusHuntId"
                                    variant="outlined"
                                    density="comfortable"
                                    color="primary"
                                    :items="bonusHuntList"
                                    :loading="loadingBonusHuntList"
                                    item-title="name"
                                    item-value="bonusHuntId"
                                    style="font-family: Saira Condensed, sans-serif;"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="timerDuration"
                                    :rules="[formRules.required, formRules.minValue]"
                                    :label="$t('Fields_Label.Guess_The_Balance.Time_Duration')"
                                    :hint="$t('Fields_Label.Guess_The_Balance.Hint')"
                                    type="number"
                                    variant="outlined"
                                    density="comfortable"
                                    color="primary"
                                    style="font-family: Saira Condensed, sans-serif;"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="requiredPoints"
                                    :rules="[formRules.required, formRules.minValue]"
                                    :label="$t('Fields_Label.Guess_The_Balance.Required_Points')"
                                    type="number"
                                    variant="outlined"
                                    density="comfortable"
                                    color="primary"
                                    style="font-family: Saira Condensed, sans-serif;"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row v-if="action == 'edit'" dense style="font-family: Saira Condensed, sans-serif;">
                            <v-col cols="12">
                                <v-text-field
                                    v-model="timerDuration"
                                    :rules="[formRules.required, formRules.minValue]"
                                    :label="$t('Fields_Label.Guess_The_Balance.Time_Duration')"
                                    :hint="$t('Fields_Label.Guess_The_Balance.Hint')"
                                    type="number"
                                    variant="outlined"
                                    density="comfortable"
                                    color="primary"
                                    style="font-family: Saira Condensed, sans-serif;"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="requiredPoints"
                                    :rules="[formRules.required, formRules.minValue]"
                                    :label="$t('Fields_Label.Guess_The_Balance.Required_Points')"
                                    type="number"
                                    variant="outlined"
                                    density="comfortable"
                                    color="primary"
                                    style="font-family: Saira Condensed, sans-serif;"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-3" style="margin-top: auto;">
                    <v-spacer></v-spacer>
                    <v-btn class="mr-1 text-subtitle-1" :disabled="loading" :text="$t('Buttons.Cancel')" variant="outlined" elevation="1" @click="closeDialog()" style="font-family: Saira Condensed, sans-serif;"></v-btn>
                    <v-btn class="mr-1 text-subtitle-1" :loading="loading" :text="$t('Buttons.Save')" variant="elevated" elevation="1" color="primary" @click="validateForm()" style="font-family: Saira Condensed, sans-serif;"></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :timeout="2500"
            :color="snackColor"
            location="top">
            <v-icon>mdi-alert-circle</v-icon>
            <span class="ml-2" style="font-family: Saira Condensed, sans-serif;">{{ snackText }}</span>
        </v-snackbar>
    </div>
</template>

<script>
import axios from 'axios'
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'BonusHuntDialog',
    emits: ['refresh'],
    data() {
        return {
            dialog: false,
            loadingBonusHuntList: false,
            
            main_title: '',
            sub_title: '',

            loading: false,
            snackbar: false,
            snackText: '',
            snackColor: '',
            
            gtbId: null,
            bonusHuntList: [],
            timerDuration: null,
            requiredPoints: null,
            bonusHuntId: null,
            formRules: {
                required: value => !!value || 'Required',
                minValue: value => (value && value > 0) || 'Must be greater than 0',
                noSpacesOnly: value => (value && value.trim().length > 0) || 'This cannot be just spaces'
            }
        }
    },
    methods: {
        async validateForm(){
            const { valid } = await this.$refs.form.validate()

            if (valid) {
                const token = localStorage.getItem('maherco-admin-accesstoken')
                
                const formData = {
                    timerDuration: Number(this.timerDuration),
                    requiredPoints: Number(this.requiredPoints)
                };

                this.loading = true
                if(this.action == 'add') {
                    formData.bonusHuntId = Number(this.bonusHuntId);
                    axios.post(process.env.VUE_APP_SERVER_URL + '/api/admin/guess-the-balance', formData, { 
                        headers: { 
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json',
                            'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                        }
                    }).then((res)=>{
                        if(res.data.status == 200 || res.data.status == 201){
                            this.$emit('refresh')
                            this.loading = false
                            this.snackText = res.data.message
                            this.snackbar = true
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error) => {
                        if (error.response) {
                            this.loading = false
                            this.snackText = error.response.data.message ?? "Something went wrong. Double check if Bonus hunt already created."
                            this.snackbar = true
                            console.log(error.response )

                            if (error.response.status === 401) {
                                    localStorage.removeItem("vuex");
                                    localStorage.removeItem("maherco-admin-accesstoken");
                                    window.location.reload();
                            } else {
                                console.log(`Error: ${error.response.status}`);
                            }
                        } 
                        else if (error.request) {
                            console.log('No response received', error.request);
                        } else {
                            console.log('Error', error.message);
                        }
                    });
                }
                else if(this.action == 'edit'){
                    axios.patch(process.env.VUE_APP_SERVER_URL + `/api/admin/guess-the-balance/${this.gtbId}`, formData, { 
                        headers: { 
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json',
                            'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                        }
                    }).then((res)=>{
                        if(res.data){
                            this.$emit('refresh')
                            this.loading = false
                            this.snackText = res.data.message
                            this.snackbar = true
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error) => {
                        if (error.response) {
                            if (error.response.status === 401) {
                                    localStorage.removeItem("vuex");
                                    localStorage.removeItem("maherco-admin-accesstoken");
                                    window.location.reload();
                            } else {
                                console.log(`Error: ${error.response.status}`);
                            }
                        } 
                        else if (error.request) {
                            console.log('No response received', error.request);
                        } else {
                            console.log('Error', error.message);
                        }
                    });
                }
            }
        },
        openDialog() {
            this.dialog = true
            this.main_title = 'Bonus Hunt Setup'
            this.sub_title = 'Configure your bonus hunt details'
        },
        closeDialog() {
            this.resetForm()
            this.dialog = false
        },
        resetForm() {
            this.bonusHunt = null
            this.timerDuration = null
            this.requiredPoints = null
        },
        async syncBonusHunt() {
            const token = localStorage.getItem('maherco-admin-accesstoken');
            try {
                this.loadingBonusHuntList = true;

                await axios.patch(
                    `${process.env.VUE_APP_SERVER_URL}/api/admin/guess-the-balance/sync`, 
                    null,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "x-admin-key": process.env.VUE_APP_X_ADMIN_KEY,
                        },
                    }
                );
                this.loadBonusHunt();
            } catch (error) {
                console.error("Failed to sync bonus hunt:", error);
            } finally {
                this.loadingBonusHuntList = false;
            }
        },
        async loadBonusHunt() {
            this.loadingBonusHuntList = true;
            const token = localStorage.getItem('maherco-admin-accesstoken');
            try {
                const res = await axios.get(
                    `${process.env.VUE_APP_SERVER_URL}/api/admin/guess-the-balance/bonus-hunts`, 
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "x-admin-key": process.env.VUE_APP_X_ADMIN_KEY,
                        },
                    }
                );
                
                if (res.data) {
                    this.bonusHuntList = res.data.bonusHunts;
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.loadingBonusHuntList = false;
            }
        },
        async initAdd(){
            this.dialog = true
            this.main_title = this.$t('DialogTitle.Add_GTB.Header') 
            this.sub_title = this.$t('DialogTitle.Add_GTB.Sub_Title') 
            this.action = 'add'

            await this.loadBonusHunt();

        },
        async initUpdate(data) {
            console.log(data)
            this.dialog = true
            this.main_title = this.$t('DialogTitle.Edit_GTB.Header')
            this.sub_title = this.$t('DialogTitle.Edit_GTB.Sub_Title')
            this.action = 'edit'

            this.gtbId = data._id
            this.timerDuration = data.timerDuration 
            this.requiredPoints = data.requiredPoints
        }
    }
})
</script>

<style scoped>
.v-stepper {
    border-radius: 20px;
}

</style>